import type { CalendarBundle } from '../format/calendar';
import { useLocalizationContext } from './useLocalizationContext';

/**
 * Calendar arithmetic in the signed-in user's time zone.
 *
 * The companion to `useFormat` for the questions whose answer is a date rather than a string: which
 * day an instant falls on, when a month begins, what range a query should ask for. A feature that
 * writes its own is quietly asking about the host machine's calendar instead of the reader's.
 *
 * Identity holds for as long as the preferences do, so it is safe in a dependency array.
 *
 * @returns The bundle. See {@link CalendarBundle}.
 * @throws If no `<LocalizationProvider>` is mounted above the caller.
 */
export const useCalendar = (): CalendarBundle =>
  useLocalizationContext().calendar;
